import React from 'react';
import { Wrapper, Heading, SubHeading, Content, ImageWrapper, TopIcon, Tnc } from './styles';

const Popup1 = () => (
  <>
  <Wrapper>
    <TopIcon>
      <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/icon1.png`} alt="" width="100" />
    </TopIcon>
    <Heading>24 bit 錄音室原音重現</Heading>
    <br />
    <hr />
    <Content>
      MOOV 作為香港首個及唯一音樂串流平台在流動應用程式內提供 24 bit FLAC 無損音樂<sup>#</sup>，帶你突破實體CD的局限，全面提升音樂層次感，觸發錄音室級音樂浪潮。MOOV 從聲音開始，與你追溯音樂本源。
      <br />
      <br />
      <SubHeading>鑑聽級完美曲線  由兩個基本關鍵構成</SubHeading>
      <div>Bit depth 位元度 與  Sampling rate 取樣頻率</div>
      <br />
      <div>
      聲音是物體振動而形成，狀態如波浪型曲線。要將聲音轉化成數位音樂，就需要經過「取樣」與「量化」兩個過程，取樣及量化的過程越細緻，就越能保存音樂人製作時的原音和感動，而MOOV所提供的 24 bit / 192 kHz 無損音質，可讓你體驗錄音室原音重現，感受高階音質再進化。
      </div>
      <br />
      <ImageWrapper>
        <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/pic1.png`} alt="" width="100%" />
      </ImageWrapper>
      <br />
      <br />
      一般實體 CD 可承載的音質
      <br />
      位元度：16 bit   取樣頻率：44.1 kHz 
      <br />
      <br />
      MOOV 可提供最高的音質
      <br />
      位元度：24 bit  取樣頻率：192 kHz 
      <br />
      <br />
      <SubHeading>Bit Depth 位元度</SubHeading>
      <div>
      位元度意即每段聲波振幅可佔用的空間大小，它決定了聲音的動態範圍。24 bit 最大的動態範圍可容納到 140分貝 的聲音（等同飛機起飛時的音量），能承載錄音室原音，甚至大型音樂會及交響樂會的音樂，讓你立體感受現場音樂感。
      </div>
      <br />
      <SubHeading>Sampling Rate 取樣頻率</SubHeading>
      <div>
      取樣頻率指每秒取樣次數，將一秒的聲波切割成許多等分。取樣頻率越高，聲波分割得越細，數位訊號越接近原音。
      <br />
      <br />
錄音常用的取樣頻率為 44.1、 48、96、192 (kHz)，越高的取樣頻率，就越能保存到最多聲音數據，減少失真。而取樣密度越高，定位越見清晰，聽到的聲音會更加細緻通透。
      </div>
      <br />
      <Tnc>#根據MOOV針對在香港營運之8大音樂串流平台之內部調查。截至2020年3月16日，MOOV擁有香港最大 24 bit FLAC 無損串流音樂庫提供 24 bit FLAC 無損音樂庫及音源資訊包括位元度、取樣頻率、音頻格式、版本及位元率之音樂串流平台。</Tnc>
    </Content>
  </Wrapper>
  </>
)

export default Popup1;